import { config } from "src/config/environment";

export const getMediaCollectionLink = (uuid: string, customDomain: string | undefined) => {
  let result = `${config.galleryURL}/m/${uuid}`;

  if (customDomain) result = `https://${customDomain}/m/${uuid}`;

  return result;
};
